export default __webpack_public_path__ + "static/media/cargo-3.4ce8e457.svg";